import { render, staticRenderFns } from "./CloseButtonSettings.vue?vue&type=template&id=437dcc73&scoped=true&"
import script from "./CloseButtonSettings.vue?vue&type=script&lang=js&"
export * from "./CloseButtonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437dcc73",
  null
  
)

export default component.exports